import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {DetaillineDTOModel} from '../../../models/detaillineDTO.model';
import {NewDocumentService} from '../../../services/new-document.service';
import {DocumentTypes} from '../../../definitions/document-types';
import {ValidateDocumentService} from '../../../services/validate-document.service';
import {GeneralSaveDocumentService} from '../../../services/general-save-document.service';
import {DocumentModel} from '../../../models/document.model';
import {GeneralService} from '../../../services/general.service';
import {StateManagerService} from '../../../services/state-manager.service';
import {CollectionsNames} from '../../../definitions/collections-names';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {BarcodeOptions} from '../../../definitions/barcode-options';
import {PersistScannedBarcodesService} from '../../../services/persist-scanned-barcodes.service';
import {ScanBarcodeService} from '../../../services/scan-barcode.service';
import {FindEquipmentPriceService} from '../../../services/find-equipment-price.service';

@Component({
    selector: 'app-changeover',
    templateUrl: './changeover.component.html',
    styleUrls: ['./changeover.component.scss'],
})
export class ChangeoverComponent implements OnInit {
    @Input() document: DocumentModel;
    replacementEquipment: DetaillineDTOModel;
    brokenEquipment: DetaillineDTOModel;
    documentTemp: DocumentModel;
    manualInput: string;

    constructor(public modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private docType: DocumentTypes,
                private validateDoc: ValidateDocumentService,
                private generalSaveDocumentService: GeneralSaveDocumentService,
                private generalService: GeneralService,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                private barcodeScanner: BarcodeScanner,
                private barcodeOptions: BarcodeOptions,
                private persistScannedBarcodesService: PersistScannedBarcodesService,
                private scanBarcodeService: ScanBarcodeService,
                private findEquipmentPriceService: FindEquipmentPriceService) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
        if (this.documentTemp.detailLines && this.documentTemp.detailLines.length) {
            this.replacementEquipment = this.documentTemp.detailLines[0];
            this.brokenEquipment = this.replacementEquipment.changeOverDetailLine;
        }
        if (this.documentTemp.replacementEquipment) {
            this.replacementEquipment = this.documentTemp.replacementEquipment;
        }
        if (this.documentTemp.brokenEquipment) {
            this.brokenEquipment = this.documentTemp.brokenEquipment;
        }
    }

    async scanCode() {
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {
            console.log(barcode.text);
            this.handleScanResult(barcode.text);
        }).catch(err => {
            console.log(err);
        });
        // const modal = await this.modalController.create({
        //     component: CollectionWithBarcodeComponent,
        //     backdropDismiss: false,
        //     cssClass: 'modal-fullscreen',
        //     componentProps: {
        //         changeover: true,
        //         document: this.documentTemp
        //     }
        // });
        // modal.onDidDismiss().then(data => {
        //     if (data.data) {
        //         console.log(data.data);
        //         if (data.data.stat === 1 || data.data.stat === 200) {
        //             if (!this.replacementEquipment) {
        //                 this.replacementEquipment = new DetaillineDTOModel();
        //             }
        //             this.replacementEquipment = JSON.parse(JSON.stringify(data.data));
        //         } else {
        //             if (!this.brokenEquipment) {
        //                 this.brokenEquipment = new DetaillineDTOModel();
        //             }
        //             this.populateDocumentDetails(data.data as DetaillineDTOModel);
        //             this.brokenEquipment = JSON.parse(JSON.stringify(data.data));
        //         }
        //     }
        // });
        // return await modal.present();
    }

    handleScanResult(barcode: string) {
        this.manualInput = null;
        if (barcode) {
            const returnDetailLine = this.scanBarcodeService.findLiveLineByBarcode(barcode) as DetaillineDTOModel;
            let newEquipmentLine: DetaillineDTOModel = null;
            if (returnDetailLine) {
                if (returnDetailLine.stat !== 200) {
                    this.persistScannedBarcodesService.persistBarcode(barcode);
                    this.brokenEquipment = JSON.parse(JSON.stringify(returnDetailLine));
                    this.populateDocumentDetails(this.brokenEquipment);
                } else {
                    this.handleBufferStockOrNewEquipment(returnDetailLine);
                }
            } else {
                newEquipmentLine = this.scanBarcodeService.findPlantItemByExactBarcode(barcode);
                if (newEquipmentLine) {
                    this.handleBufferStockOrNewEquipment(newEquipmentLine);
                } else {
                    this.generalService.createToast('Equipment not found');
                }
            }
        } else {
            this.generalService.createToast('Equipment not found');
        }
    }

    handleBufferStockOrNewEquipment(newEquipmentLine: DetaillineDTOModel) {
        newEquipmentLine = this.findEquipmentPriceService.getChargeLineAndDiscount(newEquipmentLine, this.document.customer);
        newEquipmentLine.fromDate = new Date().toISOString();
        newEquipmentLine.toDate = new Date().toISOString();
        newEquipmentLine.qty = 1;
        this.replacementEquipment = JSON.parse(JSON.stringify(newEquipmentLine));
    }

    saveChangeover() {
        if (!this.replacementEquipment || !this.brokenEquipment) {
            this.documentTemp.replacementEquipment = this.replacementEquipment;
            this.documentTemp.brokenEquipment = this.brokenEquipment;
        } else {
            this.brokenEquipment.changeOverDetailLine = this.replacementEquipment;
            this.replacementEquipment.documentNumber = this.brokenEquipment.documentNumber;
            this.replacementEquipment.location = this.brokenEquipment.location;
            this.replacementEquipment.contractDocumentNumber = this.brokenEquipment.contractDocumentNumber;
            this.replacementEquipment.documentLineNumber = this.brokenEquipment.documentLineNumber;
            delete this.documentTemp.replacementEquipment;
            delete this.documentTemp.brokenEquipment;
            this.documentTemp.detailLines.push(this.brokenEquipment);
        }
        this.document = JSON.parse(JSON.stringify(this.documentTemp));
        this.generalSaveDocumentService.generalSaveDocument(this.document);
    }

    private populateDocumentDetails(detailLine: DetaillineDTOModel) {
        this.documentTemp.customer = this.stateManagerService.getCollection(this.collectionsNames.CUSTOMER)
            .find(cust => cust.id === detailLine.custId);
        this.documentTemp.site = this.stateManagerService.getCollection(this.collectionsNames.SITE)
            .find(site => site.id === detailLine.site);
    }
}
